import React, { useState } from 'react';

import moment, { Moment } from 'moment';
import { useHistory } from 'react-router';
import smartlookClient from 'smartlook-client';

import { ProductTelemetryController } from '../product-telemetry/product-telemetry-controller';
import { UiButton } from '../ui/ui-button';
import { UiPopover } from '../ui/ui-popover';
import { eventCalendarRoute } from '../web-routes';

import { EventCalendarBody } from './event-calendar-body';

import { CalendarDisplayType } from './utils/calendar-display-type';
import { isProd } from '../config/config';

type InputProps = {
  orgId: number;
  anchorRef: React.MutableRefObject<HTMLDivElement | null>;
  showPopover: boolean;
  toggleShowPopover: () => void;
};

export const EventCalendarPopover = (props: InputProps) => {
  const { orgId, anchorRef, showPopover, toggleShowPopover } = props;

  const [calendarStart, setCalendarStart] = useState<Moment>(moment());
  const history = useHistory();

  const handleRouteToFullCalendar = () => {
    if (isProd && smartlookClient) {
      smartlookClient.track('Click to Full Calendar View', { source: 'Popover' });
    }

    ProductTelemetryController.logEvent('full calendar link clicked');

    history.push(eventCalendarRoute(orgId));
    toggleShowPopover();
  };

  return showPopover ? (
    <UiPopover
      anchorRef={anchorRef}
      isShowingPopover={showPopover}
      onClose={toggleShowPopover}
      margins={{ marginTop: -8, marginLeft: 20 }}
    >
      <EventCalendarBody
        className="u-width-600px"
        orgId={orgId}
        calendarDisplay={CalendarDisplayType.PARTIAL_WEEK}
        calendarStart={calendarStart}
        setCalendarStart={setCalendarStart}
      />
      <div className="u-margin-top-md u-display-flex u-flexDirection-column u-alignItems-flexEnd">
        <UiButton variant="dismiss" onClick={handleRouteToFullCalendar}>
          View Full Calendar
        </UiButton>
      </div>
    </UiPopover>
  ) : null;
};
